"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.C3_KNOWLEDGE = [
    {
        id: 1,
        themeName: '数与量',
        planetName: '鲜花',
        knowledgePointFramework: [
            { id: 1, text: '相邻数' },
            { id: 2, text: '单双数' },
            { id: 3, text: '认识100以内的数' },
            { id: 4, text: '整十数' },
            { id: 5, text: '数位（个位和十位）' },
            { id: 6, text: '100以内数的比较' },
            { id: 7, text: '100以内数的排序' },
            { id: 8, text: '数射线' },
            { id: 9, text: '按群数数' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握100以内运算所涉及的抽象概念和工具。',
            cognitiveDevelopment: '建立抽象概念与具象问题之间的联系。',
            applicationAbility: '利用抽象工具更快捷地解决数学问题。',
        },
        trainingObjectives: { habit: '规律的学习时间。', impetus: '激发学习兴趣。' },
    },
    {
        id: 2,
        themeName: '图形与空间',
        planetName: '旋律',
        knowledgePointFramework: [
            { id: 1, text: '认识平面图形' },
            { id: 2, text: '认识立体图形' },
            { id: 3, text: '空间位置' },
            { id: 4, text: '位置关系的相对性' },
            { id: 5, text: '等分' },
            { id: 6, text: '图形分割' },
            { id: 7, text: '图形拼合' },
            { id: 8, text: '图形割补' },
            { id: 9, text: '轴对称' },
            { id: 10, text: '认识直线、线段、射线' },
            { id: 11, text: '数线段' },
            { id: 12, text: '数图形' },
            { id: 13, text: '认识角' },
            { id: 14, text: '比较角的大小' },
            { id: 15, text: '认识直角、锐角、钝角' },
            { id: 16, text: '三视图' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握图形与空间的基本概念和变化规律。',
            cognitiveDevelopment: '尝试多角度思考问题，锻炼空间想象能力。',
            applicationAbility: '利用包含多个步骤的方法解决数学问题。',
        },
        trainingObjectives: { habit: '勤于动笔，写写画画。', impetus: '树立阶段性目标。' },
    },
    {
        id: 3,
        themeName: '运算技巧',
        planetName: '甜点',
        knowledgePointFramework: [
            { id: 1, text: '一图四式' },
            { id: 2, text: '符号代换' },
            { id: 3, text: '20以内连加巧算：凑十法、搬家法、拆数凑十法' },
            { id: 4, text: '20以内连减巧算：凑十法、搬家法、破十法' },
            { id: 5, text: '100以内不进退位加减法心算：数理法&拆数法、数位对齐法' },
            { id: 6, text: '100以内加减法推算：加数变化、被减数、减数变化；一图四式' },
            { id: 7, text: '二元算式推理：加法、减法' },
            { id: 8, text: '100以内进位加法：数位对齐法、竖式' },
            { id: 9, text: '100以内退位减法：拆数法、竖式' },
            { id: 10, text: '凑整与凑百' },
            { id: 11, text: '100以内加法巧算：凑十法、凑整法、拆数凑整法' },
            { id: 12, text: '100以内减法巧算：凑十法、凑整法、搬家法、破整法' },
            { id: 13, text: '乘法引入-倍数' },
            { id: 14, text: '除法引入-均分' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握100以内加减运算的原理和多种技巧。',
            cognitiveDevelopment: '强化数感和符号感，提高运算能力。',
            applicationAbility: '在多种技巧中选择最合适的解决方法。',
        },
        trainingObjectives: { habit: '选择最合适的方法。', impetus: '具备多种可选择方法的信心。' },
    },
    {
        id: 4,
        themeName: '逻辑思维',
        planetName: '童话',
        knowledgePointFramework: [
            { id: 1, text: '归类' },
            { id: 2, text: '分类' },
            { id: 3, text: '图形规律（I）：循环' },
            { id: 4, text: '图形规律（II）：演变' },
            { id: 5, text: '图形规律（III）：品拆' },
            { id: 6, text: '图形规律（IV）：复合' },
            { id: 7, text: '数的规律（I）：等差数列' },
            { id: 8, text: '数的规律（II）：不等差数列' },
            { id: 9, text: '数的规律（III）：间隔' },
            { id: 10, text: '数的规律（IV）：分组' },
            { id: 11, text: '等量代换' },
            { id: 12, text: '集合' },
            { id: 13, text: '重叠与交集' },
            { id: 14, text: '包含与排除' },
            { id: 15, text: '逻辑推理（I）：排除法' },
            { id: 16, text: '逻辑推理（II）：矛盾分析法' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握常见的逻辑思维题型。',
            cognitiveDevelopment: '促进比较、分类、归纳、类比等分析和推理能力。',
            applicationAbility: '为复杂的数学问题创造新的解决方法。',
        },
        trainingObjectives: { habit: '通过重复加深记忆、温故知新。', impetus: '探索未知领域。' },
    },
    {
        id: 5,
        themeName: '测量与统计',
        planetName: '发条',
        knowledgePointFramework: [
            { id: 1, text: '比较轻重' },
            { id: 2, text: '比较高矮' },
            { id: 3, text: '比较长短' },
            { id: 4, text: '通过中间量比较' },
            { id: 5, text: '通过参照物比较' },
            { id: 6, text: '自然测量' },
            { id: 7, text: '直尺测量' },
            { id: 8, text: '数据整理' },
            { id: 9, text: '统计表格' },
            { id: 10, text: '条形图' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握测量与统计的初步方法。',
            cognitiveDevelopment: '形成数形结合的思维方式，体会差异的相对性。',
            applicationAbility: '把熟悉的工具迁移至新的数学问题。',
        },
        trainingObjectives: { habit: '严谨地使用方法和工具。', impetus: '体验数学知识带来的便利性。' },
    },
    {
        id: 6,
        themeName: '生活常识',
        planetName: '原始人',
        knowledgePointFramework: [
            { id: 1, text: '时钟（I）：钟面' },
            { id: 2, text: '时钟（II）：整点' },
            { id: 3, text: '时钟（III）：半点' },
            { id: 4, text: '时钟（IV）：正向时间推算' },
            { id: 5, text: '时钟（V）：逆向时间推算' },
            { id: 6, text: '顺时针和逆时针' },
            { id: 7, text: '认识人民币' },
            { id: 8, text: '购物（I）：付钱' },
            { id: 9, text: '购物（II）：找钱' },
            { id: 10, text: '人民币的换算' },
            { id: 11, text: '人民币的运算' },
            { id: 12, text: '认识日历' },
            { id: 13, text: '昨天、今天、明天、后天' },
            { id: 14, text: '日期推算' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握与时间、钱币相关的数学原理。',
            cognitiveDevelopment: '用数学思维看待日常生活。',
            applicationAbility: '识别并转化日常生活中的数学问题。',
        },
        trainingObjectives: { habit: '多思考、多提问。', impetus: '验证学习成果。' },
    },
    {
        id: 7,
        themeName: '典型问题',
        planetName: '冠军',
        knowledgePointFramework: [
            { id: 1, text: '火柴棒问题' },
            { id: 2, text: '单双数' },
            { id: 3, text: '七巧板' },
            { id: 4, text: '数小方块' },
            { id: 5, text: '间隔问题' },
            { id: 6, text: '蜗牛爬井问题' },
            { id: 7, text: '鸡兔同笼' },
            { id: 8, text: '排队问题' },
            { id: 9, text: '行程问题' },
            { id: 10, text: '简单年龄问题' },
            { id: 11, text: '明差问题' },
            { id: 12, text: '暗差问题' },
        ],
        learningObjectives: {
            subjectKnowledge: '掌握本阶段数学应用题中的典型问题。',
            cognitiveDevelopment: '从数学问题中抽象出思维模型。',
            applicationAbility: '分析问题、分解步骤、选择方法的综合能力。',
        },
        trainingObjectives: { habit: '定期梳理总结。', impetus: '不断挑战自我。' },
    },
];
exports.C1_C2_KNOWLEDGE = {
    id: 0,
    themeName: '运算基础',
    planetName: '数学',
    knowledgePointFramework: [
        { id: 1, text: '认识数1~20' },
        { id: 2, text: '20以内数量对应' },
        { id: 3, text: '整体认数—建形' },
        { id: 4, text: '10以内实物加减法' },
        { id: 5, text: '10以内数比大小' },
        { id: 6, text: '10以内心象加减法' },
        { id: 7, text: '凑十' },
        { id: 8, text: '10以内抽象加减法' },
        { id: 9, text: '20以内不进退位加减法' },
        { id: 10, text: '20以内进退位加减法' },
        { id: 11, text: '20以内连加、连减、混合运算' },
    ],
    learningObjectives: {
        subjectKnowledge: '理解加减法的实际含义，掌握20以内的加减法以及简单的巧算方法。',
        cognitiveDevelopment: '建立数感和符号感。',
        applicationAbility: '能将抽象的数学问题与具体的实际问题相互转化。',
    },
    trainingObjectives: {
        habit: '把学习跟快乐的情绪联系起来，从数学的角度思考问题。',
        impetus: '运用知识简化和解决问题。',
    },
};
exports.C99X_C49_KNOWLEDGE = {
    id: 0,
    themeName: '运算基础',
    planetName: '数学',
    knowledgePointFramework: [
        { id: 1, text: '认识数1~10' },
        { id: 2, text: '10以内数量对应' },
        { id: 3, text: '数10以内的个数' },
        { id: 4, text: '数出10以内的个数' },
        { id: 5, text: '10以内整体认数-建形' },
        { id: 6, text: '5以内实物加法' },
        { id: 7, text: '加号' },
        { id: 8, text: '等于号' },
        { id: 9, text: '5以内实物减法' },
        { id: 10, text: '减号' },
        { id: 11, text: '0的含义' },
        { id: 12, text: '10以内实物加法' },
        { id: 13, text: '10以内整体认数(II)' },
        { id: 14, text: '实物凑十' },
        { id: 15, text: '加法算式(I)' },
        { id: 16, text: '10以内实物减法(I)' },
        { id: 17, text: '减法算式(I)' },
        { id: 18, text: '10以内数量比多少' },
        { id: 19, text: '10以内实物减法(II)' },
        { id: 20, text: '10以内数比大小' },
        { id: 21, text: '大于号小于号' },
        { id: 22, text: '排序' },
        { id: 23, text: '5以内数的分解' },
        { id: 24, text: '5以内数的合成' },
        { id: 25, text: '分合式(I)' },
        { id: 26, text: '加法算式(II)' },
        { id: 27, text: '减法算式(II)' },
    ],
    learningObjectives: {
        subjectKnowledge: '掌握“建形”的认数方法以及加减法的实际含义。',
        cognitiveDevelopment: '建立数感和符号感。',
        applicationAbility: '识别实物数量变化过程中的加法和减法。',
    },
    trainingObjectives: {
        habit: '把学习跟快乐的情绪联系起来。',
        impetus: '拓宽对日常生活的理解维度。',
    },
};
exports.C91_KNOWLEDGE = {
    id: 0,
    themeName: '运算基础',
    planetName: '数学',
    knowledgePointFramework: [
        { id: 1, text: '认识数1~10' },
        { id: 2, text: '10以内数量对应' },
        { id: 3, text: '数10以内的个数' },
        { id: 4, text: '数出10以内的个数' },
        { id: 5, text: '10以内整体认数-建形' },
        { id: 6, text: '5以内实物加法' },
        { id: 7, text: '加号' },
        { id: 8, text: '等于号' },
        { id: 9, text: '5以内实物减法' },
        { id: 10, text: '减号' },
        { id: 11, text: '0的含义' },
    ],
    learningObjectives: {
        subjectKnowledge: '掌握“建形”的认数方法以及加减法的实际含义。',
        cognitiveDevelopment: '建立数感和符号感。',
        applicationAbility: '识别实物数量变化过程中的加法和减法。',
    },
    trainingObjectives: {
        habit: '把学习跟快乐的情绪联系起来。',
        impetus: '拓宽对日常生活的理解维度。',
    },
};
exports.C92_KNOWLEDGE = {
    id: 0,
    themeName: '运算基础',
    planetName: '数学',
    knowledgePointFramework: [
        { id: 1, text: '10以内实物加法' },
        { id: 2, text: '10以内整体认数-建形' },
        { id: 3, text: '实物凑十' },
        { id: 4, text: '加法算式' },
        { id: 5, text: '10以内实物减法I-求剩余、求部分' },
        { id: 6, text: '减法算式' },
        { id: 7, text: '10以内数量比多少' },
        { id: 8, text: '10以内实物减法II-求差异' },
        { id: 9, text: '10以内数比大小' },
        { id: 10, text: '大于号小于号' },
        { id: 11, text: '10以内实物连加' },
        { id: 12, text: '10以内实物连减' },
        { id: 13, text: '10以内实物混合加减' },
    ],
    learningObjectives: {
        subjectKnowledge: '掌握“实物凑十”、10以内的实物加减法以及加减法的实际含义。',
        cognitiveDevelopment: '建立数理概念与生活现象之间的联系。',
        applicationAbility: '尝试多步骤的问题解决模式。',
    },
    trainingObjectives: {
        habit: '主动学习。',
        impetus: '运用知识简化问题。',
    },
};
exports.C93_KNOWLEDGE = {
    id: 0,
    themeName: '运算基础',
    planetName: '数学',
    knowledgePointFramework: [
        { id: 1, text: '5以内心象加法' },
        { id: 2, text: '5以内心象减法' },
        { id: 3, text: '10以内心象加法' },
        { id: 4, text: '10以内心象减法' },
        { id: 5, text: '“10”的所有分与合' },
        { id: 6, text: '实物凑十' },
        { id: 7, text: '抽象凑十' },
        { id: 8, text: '列加法算式-求总数' },
        { id: 9, text: '列减法算式I-求剩余' },
        { id: 10, text: '列减法算式II-求部分' },
    ],
    learningObjectives: {
        subjectKnowledge: '掌握“抽象凑十”、10以内的心象加减法，根据加减法的实际含义列出算式。',
        cognitiveDevelopment: '通过构建心理图像逐步脱离实物运算。',
        applicationAbility: '把抽象问题转化为具体问题。',
    },
    trainingObjectives: {
        habit: '从数学的角度思考问题。',
        impetus: '运用知识解决问题。',
    },
};
exports.C4_KNOWLEDGE = {
    id: 0,
    themeName: '运算基础',
    planetName: '数学',
    knowledgePointFramework: [
        { id: 1, text: '10以内实物加法-求总数' },
        { id: 2, text: '实物凑十-判断' },
        { id: 3, text: '10以内实物减法-求剩余' },
        { id: 4, text: '10以内实物减法-求部分' },
    ],
    learningObjectives: {
        subjectKnowledge: '掌握“实物凑十”、10以内的实物加减法以及加减法的实际含义。',
        cognitiveDevelopment: '建立数理概念与生活现象之间的联系。',
        applicationAbility: '尝试多步骤的问题解决模式。',
    },
    trainingObjectives: {
        habit: '主动学习。',
        impetus: '运用知识简化问题。',
    },
};
var CourseSerialIds;
(function (CourseSerialIds) {
    CourseSerialIds["C1"] = "C1";
    CourseSerialIds["C2"] = "C2";
    CourseSerialIds["C3"] = "C3";
    CourseSerialIds["C31"] = "C31";
    CourseSerialIds["C32"] = "C32";
    CourseSerialIds["C33"] = "C33";
    CourseSerialIds["C91"] = "C91";
    CourseSerialIds["C92"] = "C92";
    CourseSerialIds["C93"] = "C93";
    CourseSerialIds["C991"] = "C991";
    CourseSerialIds["C992"] = "C992";
    CourseSerialIds["C993"] = "C993";
    CourseSerialIds["C200"] = "C200";
    CourseSerialIds["C216"] = "C216";
    CourseSerialIds["C4"] = "C4";
})(CourseSerialIds || (CourseSerialIds = {}));
exports.MATH_KNOWLEDGE = (_a = {},
    _a[CourseSerialIds.C1] = exports.C1_C2_KNOWLEDGE,
    _a[CourseSerialIds.C2] = exports.C1_C2_KNOWLEDGE,
    _a[CourseSerialIds.C200] = exports.C1_C2_KNOWLEDGE,
    _a[CourseSerialIds.C216] = exports.C1_C2_KNOWLEDGE,
    _a[CourseSerialIds.C91] = exports.C91_KNOWLEDGE,
    _a[CourseSerialIds.C92] = exports.C92_KNOWLEDGE,
    _a[CourseSerialIds.C93] = exports.C93_KNOWLEDGE,
    _a[CourseSerialIds.C991] = exports.C99X_C49_KNOWLEDGE,
    _a[CourseSerialIds.C992] = exports.C99X_C49_KNOWLEDGE,
    _a[CourseSerialIds.C993] = exports.C99X_C49_KNOWLEDGE,
    _a[CourseSerialIds.C4] = exports.C4_KNOWLEDGE,
    _a);
exports.COURSESERIALIDS = [
    'C1',
    'C2',
    'C3',
    'C31',
    'C32',
    'C33',
    'C91',
    'C92',
    'C93',
    'C991',
    'C992',
    'C993',
    'C200',
    'C216',
    'C4',
];
//# sourceMappingURL=knowledges.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/knowledges.js
// module id = 1014
// module chunks = 0